import * as action from './action_types';

export function userAuth(token) {
    return {
        type: action.API_USERAUTH_FETCH,
        token: token
    }
};




// WEBPACK FOOTER //
// ./src/redux/actions/userAuthentication/action.js